/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Is_Network_ActivityInputs */

const fr_help_is_network_activity = /** @type {(inputs: Help_Is_Network_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un outil ludique pour visualiser l'activité globale d'un réseau.`)
};

const en_help_is_network_activity = /** @type {(inputs: Help_Is_Network_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A playful tool for viewing overall network activity.`)
};

/**
* | output |
* | --- |
* | "A playful tool for viewing overall network activity." |
*
* @param {Help_Is_Network_ActivityInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const help_is_network_activity = /** @type {((inputs?: Help_Is_Network_ActivityInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Is_Network_ActivityInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_help_is_network_activity(inputs)
	return en_help_is_network_activity(inputs)
});